// export const API_BASE_URL =
// process.env.NODE_ENV == "production" ||
// process.env.REACT_APP_DEV_REMOTE == "remote"
// ? "http://localhost:8888/api/"
// : "http://localhost:8888/api/"

// export const API_BASE_URL = "https://api.khojabusiness.genetechz.com/api/";

// export const IMAGE_URL = "https://api.khojabusiness.genetechz.com/user/";
// export const IMAGE_URL_UPLOAD = "https://api.khojabusiness.genetechz.com/uploads/user/";
// export const IMAGE_URL_BUSINESS = "https://api.khojabusiness.genetechz.com/user/business_profile/";

// export const ACCESS_TOKEN_NAME = "x-auth-token"
// console.log(process.env.NODE_ENV);

const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const API_BASE_URL = isDevelopment
  ? "http://localhost:8888/api/" //  local backend API
  : "https://api.khojabusiness.genetechz.com/api/";


export const IMAGE_URL = isDevelopment
  ? "http://localhost:8888/user/"
  : "https://api.khojabusiness.genetechz.com/user/";

export const IMAGE_URL_UPLOAD = isDevelopment
  ? "http://localhost:8888/uploads/user/"
  : "https://api.khojabusiness.genetechz.com/uploads/user/";

export const IMAGE_URL_BUSINESS = isDevelopment
  ? "http://localhost:8888/user/business_profile/"
  : "https://api.khojabusiness.genetechz.com/user/business_profile/";

export const ACCESS_TOKEN_NAME = "x-auth-token";
